import { MenuButton } from './MenuButton';
import { MenuContent } from './MenuContent';
import { MenuIconButton } from './MenuIconButton';
import { MenuItem, MenuRow } from './MenuItem';
import { MenuNote } from './MenuNote';
import { CheckboxMarker, MenuOptions, SearchableOptions, SelectedMarker } from './MenuOptions';
import { MenuRoot, SubmenuRoot } from './MenuRoot';
import { MenuScrollable } from './MenuScrollable';
import { MenuSection } from './MenuSection';
import { MenuSeparator, MenuSpacer } from './MenuSeparator';
import { MenuTrigger } from './MenuTrigger';
import { SubmenuContent } from './SubmenuContent';
import { SubmenuTrigger } from './SubmenuTrigger';

/**
 * Menu
 *
 * Compound component that manages open/close state for a dropdown menu. Wrap a
 * trigger and content together:
 *
 * ```tsx
 * <Menu>
 *   <Menu.Trigger><button>Open</button></Menu.Trigger>
 *   <Menu.Content>
 *     <Menu.Item label="Action" onClick={...} />
 *   </Menu.Content>
 * </Menu>
 * ```
 *
 * For nested menus, place `<Submenu>` inside `<Menu.Content>`, with a
 * `<Menu.Item>` as the `<Submenu.Trigger>`:
 *
 * ```tsx
 * <Menu.Content>
 *   <Menu.Item label="Edit" onClick={...} />
 *   <Submenu>
 *     <Submenu.Trigger>
 *       <Menu.Item label="More options" />
 *     </Submenu.Trigger>
 *     <Submenu.Content>
 *       <Menu.Item label="Duplicate" onClick={...} />
 *     </Submenu.Content>
 *   </Submenu>
 * </Menu.Content>
 * ```
 */

export const Menu = Object.assign(MenuRoot, {
  Trigger: MenuTrigger,
  Button: MenuButton,
  IconButton: MenuIconButton,
  Content: MenuContent,
  Scrollable: MenuScrollable,
  Row: MenuRow,
  SelectedMarker,
  CheckboxMarker,
  Item: MenuItem,
  Options: MenuOptions,
  SearchableOptions,
  Section: MenuSection,
  Note: MenuNote,
  Separator: MenuSeparator,
  Spacer: MenuSpacer,
});

export const Submenu = Object.assign(SubmenuRoot, {
  Trigger: SubmenuTrigger,
  Content: SubmenuContent,
});
